export const followUpOptions = {
  0: {
    label: "初始",
    value: 0
  },
  1: {
    label: "已分配",
    value: 1
  },
  2: {
    label: "跟进中",
    value: 2
  },
  3: {
    label: "有意向",
    value: 3
  },
  4: {
    label: "预约上门",
    value: 4
  },
  5: {
    label: "已上门",
    value: 5
  },
  6: {
    label: "已签约",
    value: 6
  },
  7: {
    label: "进件，已付诚意金",
    value: 7
  },
  8: {
    label: "已交付",
    value: 8
  },
  9: {
    label: "进件完成",
    value: 9
  }
};

export const startOptions = {
  0: {
    label: "0星",
    value: "0"
  },
  1: {
    label: "1星",
    value: "1"
  },
  2: {
    label: "2星",
    value: "2"
  },
  3: {
    label: "3星",
    value: "3"
  },
  4: {
    label: "4星",
    value: "4"
  },
  5: {
    label: "5星",
    value: "5"
  }
};
export const passOptions = {
  0: {
    label: "新客户未联系",
    value: 0
  },
  1: {
    label: "未接",
    value: 1
  },
  2: {
    label: "关机",
    value: 2
  },
  3: {
    label: "拒接",
    value: 3
  },
  4: {
    label: "通话中",
    value: 4
  },
  5: {
    label: "外地",
    value: 5
  },
  6: {
    label: "已接通",
    value: 6
  }
};
export const effectiveOptions = [
  {
    label: "无效",
    value: 0
  },
  {
    label: "有效",
    value: 1
  }
];
